import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { ExportClientsActions } from "store/ducks/settings/clients";

export function* exportClientsRequest(action: any) {
  try {
    const { payload, meta } = action;
    const { query = {} } = payload;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/clients?${queryString}`
    );

    const { clients, pagination } = responseBody;

    if (meta?.onSuccess) {
      yield call(meta.onSuccess, clients);
    }

    yield put(ExportClientsActions.success(clients, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ExportClientsActions.failure(errorMessage));
  }
}
